<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px">
            <el-row>
                <div class="link-name" v-text="config['award_name']"></div>
                <el-button size="mini" @click="openDialog"
                           v-text="config['award_name'] ? '更换规则' : '请选择规则'"></el-button>
            </el-row>
        </el-form-item>
        <el-dialog title="请选择表单" :visible.sync="dialog.visible" @close='closeDialog'>
            <select-rule :url="tableList.url" @close='closeDialog' :searchLabel="tableList.searchLabel"
                         :resultArrayName="tableList.resultArrayName" :titleName="tableList.titleName"
                         :count="tableList.count" @select="select" :idList="idList"></select-rule>
        </el-dialog>
    </div>
</template>

<style lang="scss">
</style>

<script>

  import SelectRule from "../../../../views/cms/helper/SelectRule";
  export default {
    name: 'tms-type-link',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
       source: {
        type: String,
      }
      // config: {
      //   type: Object,
      //   default() {
      //     return {}
      //   }
      // }
    },
    computed: {
      // 右侧组件数据初始化
      config() {
        if (this.source === 'tmsPageConfig') {
        return this.$store.state.tms.pageData
        }
        if (this.source === 'tmsModuleConfig') {
        return this.$store.state.tms.config;
        }
        return this.$store.state.tms.customConfig;
      }
    },
    data() {
      return {
        dialog: {
          visible: false
        },
        activeName: 'normal',
        tableList: {
          url: 'ec/b/operation/activity/award/rule/list/tms',
          searchLabel: '',
          titleName: 'name',
          resultArrayName: 'form_list',
          count: 10
        },
        idList: []
      }
    },

    components: {
      SelectRule
    },

    mounted() {
      this.idList[0] = this.config.link_data.id
    },

    methods: {
      openDialog() {
        this.dialog.visible = true;
      },
      closeDialog() {
        this.dialog.visible = false;
      },
      select(row) {
        this.config['active_id'] = row.activity_id;
        this.config['rule_id'] = row.id;
        this.config['award_name'] = row.award_name;
        this.$set(this.config, this.field.key, row);
        this.dialog.visible = false;
      }
    }
  }

</script>
